import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-processing-storage',
  templateUrl: './processing-storage.component.html',
  styleUrls: ['./processing-storage.component.scss'],
})
export class ProcessingStorageComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  storageData: any;
  storageForm!: FormGroup;
  storageAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  processingStorageList: any;
  regionList: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewStorageEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.storageData = this.modal?.modalService?.config?.initialState?.['newStorageData'];
    this.isDisabledDropDown = this.modalLabel == 'Review storage detail' ? true : false;
    this.indicatorList = this.storageData.indicatiorList;
    const flattenedArray = this.storageData.storageItems
      .map((item: any) => item.childItems)
      .reduce((acc: any, val: any) => acc.concat(val), []);
    this.processingStorageList = flattenedArray;
    this.regionList = this.storageData.regionItems;
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.storageData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.storageForm = new FormGroup(form);
    this.storageAddEditForm = this.formBuilder.group({
      storageName: [this.storageData.storageId || null, Validators.required],
      region: [null, Validators.required],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChange(value: any) {
    this.storageAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService.GetRegionsForStorage(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForRegion(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.storageData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.storageAddEditForm.patchValue({ region: this.selectRegion });
  }

  onSave() {
    this.submitted = true;
    if (
      this.storageAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'processing-data-conversion' &&
        !this.storageAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.storageAddEditForm.status == 'VALID' && this.storageForm.status == 'VALID') {
      const entires = Object.entries(this.storageForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.storageData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const storagePayload = {
        storageId: this.storageAddEditForm.controls['storageName'].value,
        regionId: this.storageAddEditForm.controls['region'].value?.id || this.storageData.regionId,
        organizationId: this.storageData.organizationId,
        indicatiorList: resultArray,
      };
      this.saveNewStorageEvent.emit(storagePayload);
      this.onClose();
    }
  }
}
